/* @flow */
import { lap } from '@braindate/ui/lib/token/mediaQuery';
import { mobileBarHeight } from 'src/shared/app/nav/style/nav.style';
import { takeOverElevation } from 'src/shared/app/base/style/token/elevation';
import {
  templateRoot,
  templateMain,
  templateAside,
  templateContent,
  templateContentInner,
  templateContainer,
} from './style/template.style';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    extend: templateRoot,
    padding: 0,
  },

  main: {
    extend: templateMain,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },

  aside: {
    extend: templateAside,
  },

  content: {
    extend: templateContent,
    paddingBottom: mobileBarHeight,
    [lap]: {
      paddingBottom: 0,
    },
  },
  takeOverContainer: {
    zIndex: takeOverElevation,
  },
  contentInner: {
    extend: templateContentInner,
    width: '100%',
    maxWidth: ({
      contentMaxWidth,
    }: ThemeFunction<{ contentMaxWidth?: number }>) => contentMaxWidth,
    margin: '0 auto',
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  container: {
    extend: templateContainer,
  },
};
